/**
 * API Clients Module Configuration
 *
 * Manages API clients for machine-to-machine authentication.
 * Hidden from top-level sidebar - accessed via Settings navigation group.
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const apiClientsModule: AppModule = {
    id: 'api-clients',

    navigation: {
        label: 'API Clients',
        icon: 'key',
        path: '/api-clients',
        order: 92,
        moduleKey: 'settings.api_clients',
        showInSidebar: false, // Accessed via Settings group


        pages: [
            {
                label: 'All API Clients',
                path: '/api-clients',
            },
            {
                label: 'Create API Client',
                path: '/api-clients/create',
            },
        ],
    },

    routes,
}

export default apiClientsModule
